class ProductListViewEventListener {
    // Language: javascript
    // Path: ProductListViewEventListener.js
    // Compare this snippet from EventListener.js:

    get ProductList() {
        return ".gtm-product-list";
    }
    get AllDetailProductSelector() {
        return "gtm-add-to-cart";
    }
    get DefaultEventName() {
        return "click";
    }
    get AddTypes() {
        return {
            category_product_list: "Category Product List",
            related_product_list: "Related Product List",
            lastview_product_list: "LastView Product List",
            product_collection: "Product Collection",
        };
    }

    constructor(element, eventName = this.DefaultEventName) {
        this.element = element;
        this.eventName = eventName;
    }

    callback() {
        const dataLayer = new DataLayer();
        dataLayer.clear();
        var type = this.element.dataset.addtype || "category_product_list";
        var typeName = ProductSelectItemListener.prototype.AddTypes[type];

        var allProduct =
            this.element.getElementsByClassName("gtm-product-click");
        var allProductArry = [...allProduct];
        var items = [];
        const key = "code";
        const arrayUniqueByKey = [
            ...new Map(
                allProductArry.map((item) => [item.dataset[key], item])
            ).values(),
        ];

        for (const product of arrayUniqueByKey) {
            var analyticsData = product.dataset.analytics
                ? JSON.parse(product.dataset.analytics)
                : null;
            if (analyticsData && product.dataset) {
                var analticsDataProducts = analyticsData.products
                    ? analyticsData.products[0]
                    : null;

                var price = Number(
                    product.dataset.price.replace(",", ".")
                ).toFixed(2);
                var pricewithdiscount = Number(
                    product.dataset.priceWithDiscount.replace(",", ".")
                ).toFixed(2);
                var item = {
                    item_id: analticsDataProducts.code,
                    item_name: analticsDataProducts.name,
                    currency: analticsDataProducts.currency,
                    item_brand: analticsDataProducts.brand,
                    item_category: analticsDataProducts.category,
                    price: pricewithdiscount,
                    quantity: analticsDataProducts.quantity,
                };

                if (analticsDataProducts.categories) {
                    var splitCategories =
                        analticsDataProducts.categories.split(";");
                    for (var j = 0; j < splitCategories.length; j++) {
                        if (j == 0) {
                            item["item_category"] = splitCategories[j];
                        } else {
                            item["item_category" + j] = splitCategories[j];
                        }
                    }
                }

                if (price != pricewithdiscount) {
                    item["price"] = analticsDataProducts.price;
                    item["discount"] = (price - pricewithdiscount).toFixed(2);
                }

                items.push(item);
            }
        }

        if (items.length > 0) {
            SendData(dataLayer);
        }

        function SendData(dataLayer) {
            dataLayer
                .push({
                    event: "view_item_list",
                    ecommerce: {
                        item_list_id: type,
                        item_list_name: typeName,
                        items: items,
                    },
                })
                .then(() => {
                    console.log("GTM pushed view_item_list event");
                    setTimeout(() => {
                        var instanceActivate = new ActivateGtm();
                        instanceActivate.activateRemoveFromCart();
                    }, 2000);
                })
                .catch((error) => {
                    console.warn("GTM error view_item_list event", error);
                });

            if (typeof gtag !== "undefined" && !!gtag) {
                gtag("event", "view_item_list", {
                    event_category: "Enhanced Ecommerce",
                    event_label: "view item list",
                    item_list_id: type,
                    item_list_name: typeName,
                    items: items,
                });
            }
        }
    }

    listen() {
        this.element.addEventListener(
            this.eventName,
            ProductListViewEventListener.prototype.callback
        );
    }

    remove() {
        this.element.removeEventListener(
            this.eventName,
            ProductListViewEventListener.prototype.callback
        );
    }
}
